export enum TerritoryTypePermission {
  VIEW,
  EDIT,
}
